export default __webpack_public_path__ + "static/media/settingsico.dfe2657e.svg";